module.exports = __webpack_public_path__ + "static/media/estonia.c0efdb96.svg";